import { FileDown, Loader2 } from "lucide-react";
import { trpc } from "@/lib/trpc";

const quando = (d: Date | string) =>
  new Date(d).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

/**
 * Quem levou dados pra fora, e o quê: planilhas, a exportação completa e as impressões auditadas.
 * É a contrapartida da permissão de exportar — liberar pra alguém fica visível aqui.
 */
export function RegistroDeExportacoesSecao() {
  const registro = trpc.planilha.registro.useQuery();
  const linhas = registro.data ?? [];

  return (
    <div className="space-y-4 px-6 py-5">
      <div>
        <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Exportações dos últimos 90 dias</h3>
        <p className="mt-1 text-[12.5px] text-zinc-500 dark:text-muted-foreground">
          Cada planilha baixada, exportação completa e impressão de anamnese ou orçamento, com quem fez. Quem pode
          exportar cada planilha se define em Permissões.
        </p>
      </div>

      {registro.isLoading ? (
        <p className="flex items-center gap-2 py-6 text-sm text-zinc-500">
          <Loader2 className="h-4 w-4 animate-spin" /> Carregando…
        </p>
      ) : linhas.length === 0 ? (
        <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-zinc-200 px-6 py-10 text-center dark:border-border">
          <FileDown className="h-5 w-5 text-zinc-400" />
          <p className="text-[12.5px] text-zinc-500 dark:text-muted-foreground">Nenhuma exportação nos últimos 90 dias.</p>
        </div>
      ) : (
        <ul className="divide-y divide-zinc-100 rounded-lg border border-zinc-200 dark:divide-border/50 dark:border-border">
          {linhas.map((l) => (
            <li key={l.id} className="flex flex-col gap-0.5 px-4 py-3 sm:flex-row sm:items-start sm:gap-4">
              <span className="w-36 shrink-0 text-xs tabular-nums text-zinc-500 dark:text-muted-foreground">{quando(l.quando)}</span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm text-zinc-900 dark:text-foreground">
                  <strong className="font-semibold">{l.pessoa}</strong> · {l.oQue}
                </span>
                {l.detalhes && <span className="block break-words text-xs text-zinc-500 dark:text-muted-foreground">{l.detalhes}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
